import React from 'react';

import PropTypes from 'prop-types';
import Rating from 'react-rating';
import styled from 'styled-components';

import NewThemeIcon from '../NewThemeIcon/NewThemeIcon';

export const Container = styled.span`
  display: inline-block;
  margin-top: -4px;
  ${props => (props.readonly ? 'pointer-events: none' : null)};
  svg {
    a:link & {
      /* Fix 'cursor: auto' issue caused by react-rating inline styles */
      cursor: pointer;
    }
    margin: 0 1px;
  }
`;

/**
 * Star rating component that uses [react-rating](https://github.com/dreyescat/react-rating)
 * under the hood. Any remaining props beyond those documented below are passed
 * along to its `Rating` component.
 */
function Stars({
  className,
  size = 14,
  color = 'black',
  readonly = false,
  ...props
}) {
  const starProps = { size, color };

  return (
    <Container
      className={className}
      readonly={readonly}
      $size={size}
      data-autotag="user-stars"
    >
      <Rating
        fractions={2}
        fullSymbol={
          <NewThemeIcon type="star" data-testid="StarFull" {...starProps} />
        }
        emptySymbol={
          <NewThemeIcon
            type="starOutline"
            data-testid="StarEmpty"
            {...starProps}
          />
        }
        readonly={readonly}
        {...props}
      />
    </Container>
  );
}

Stars.propTypes = {
  ...Rating.propTypes,
  /**
   * Class name(s) to apply to the container element.
   */
  className: PropTypes.string,
  /**
   * Icon size to pass along to the default star icons.
   */
  size: PropTypes.number,
  /**
   * Icon color to pass along to the default star icons.
   */
  color: PropTypes.string,
  readonly: PropTypes.bool,
};

export default Stars;
